/* tslint:disable */
/* eslint-disable */
/* @relayHash b1bfd749d6f0b393100473d29754e354 */

import { ConcreteRequest } from "relay-runtime";
export type SourceAttributionInput = {
    guestUserId?: string | null;
    landingPage?: string | null;
    type: string;
    userId: string;
    userToken?: string | null;
    emailToken?: string | null;
    visitCount?: number | null;
    pageVisits?: Array<pageVisits | null> | null;
    clientMutationId?: string | null;
};
export type pageVisits = {
    date?: string | null;
    type?: string | null;
    utmParams?: utmParams | null;
};
export type utmParams = {
    landingPage?: string | null;
    visitCount?: number | null;
};
export type sourceAttributionMutationVariables = {
    input: SourceAttributionInput;
};
export type sourceAttributionMutationResponse = {
    readonly sourceAttribution: {
        readonly message: string | null;
    } | null;
};
export type sourceAttributionMutation = {
    readonly response: sourceAttributionMutationResponse;
    readonly variables: sourceAttributionMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "SourceAttributionInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "sourceAttribution",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "message",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "sourceAttributionMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "sourceAttributionMutation",
    "id": "ferrum/255.0.0-2020-03-10T14:28:54.909Z/sourceAttributionMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '0776fc099f129d46b7995c62aa8613ee';
export default node;
